import { hideOverlay, showOverlay } from "./block-page-for-user";
export function ajaxFilter($) {
  jQuery(document).ready(function ($) {
    // Initialize Select2 on the multi-select dropdown
    $('#promotion_model').select2({
      placeholder: "All Models",
      allowClear: true
    });

    // Trigger the filterPosts function when the dropdown changes
    $('#promotion_model').change(function () {
      filterPosts();
    });

    // When any promotion filter checkbox changes
    $('.form-check-input').change(function () {
      filterPosts();
    });
    function filterPosts() {
      // Get selected promotion models
      var selectedModels = $('#promotion_model').val();

      // Get selected promotion filters (checkboxes)
      var selectedFilters = [];
      $('.form-check-input:checked').each(function () {
        selectedFilters.push($(this).val());
      });

      // Perform the AJAX request
      $.ajax({
        url: think_localize_obj.ajax_url,
        type: 'POST',
        data: {
          action: 'filter_promotion_posts',
          promotion_model: selectedModels,
          promotion_filters: selectedFilters
        },
        success: function success(response) {
          $('#filtered-posts').html(response);
        }
      });
    }
  });
}